import { jsx as o } from "react/jsx-runtime";
import r from "./Toast.module.css.js";
import { IconButton as s } from "../IconButton/IconButton.js";
import { Close as e } from "../../foundations/icons/Close.js";
const i = ({ closeToast: t }) => /* @__PURE__ */ o(s, { className: r.closeIconButton, ariaLabel: "Close", onClick: t, children: /* @__PURE__ */ o(e, {}) });
export {
  i as CloseButton
};
//# sourceMappingURL=CloseButton.js.map
